<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title">
          <h1>공지사항 관리</h1>
        </div>
        <section>
          <div class="row4">
            <div class="aRow5">
              <div class="flex flexAlignS bdBttom">
                <div class="detailInputBox">
                  <label>제목</label>
                  <input
                    ref="title"
                    v-model="saveData.title"
                    placeholder="제목을 작성해주세요."
                    maxlength="85"
                    style="width: 600px;"
                  />
                </div>
                <div class="detailInputBox flex flexAlignC">
                  <label>첨부파일</label>
                  <div class="detailFileInputBox">
                    <SingleFileUpload
                      v-bind:saveData="saveData"
                      @set-file="setFile"
                    ></SingleFileUpload>
                  </div>
                </div>
              </div>
              <!-- <Editor ref="editor"></Editor> -->
              <div class="detailTxtBox">
                <textarea
                  class="detailTxtBoxItem"
                  placeholder="내용을 입력해주세요."
                  v-model="saveData.content"
                ></textarea>
              </div>
            </div>

            <div class="btnBox">
              <button @click="listBtnGo()" class="redborderBtn">취 소</button>
              <button @click="noticeSubmit" class="redBtn">
                {{ submitText }}
              </button>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
/* import Editor from '@/components/layout/board/Editor' */
import SingleFileUpload from "@/components/layout/board/SingleFileUpload";
import axios from "@/axios/axios";

export default {
  components: {
    /* Editor, */
    SingleFileUpload,
  },
  data() {
    return {
      submitText: "등 록",
      saveData: {
        idx: "",
        title: "",
        content: "",
        file: null,
        fileGroupId: "",
        fileName: "",
      },
    };
  },
  mounted() {
    let idx = this.$route.params.idx;
    let param = {
      IDX: idx,
    };

    if (idx) {
      axios
        .post("/api/notice/getNoticeInfo", param)
        .then((response) => {
          if (response.status == 200) {
            let noticeData = response.data.NOTICE;
            this.saveData.idx = noticeData.IDX;
            this.saveData.title = noticeData.TITLE;
            this.saveData.content = noticeData.CONTENT;
            this.saveData.fileGroupId = noticeData.FILE_GROUP_ID;
            this.saveData.fileName = noticeData.FILE_NAME;

            this.submitText = "수 정";
          }
        })
        .catch((error) => {
          this.$alert(
            "알림",
            `공지사항 상세보기 불러오는데 실패하였습니다. <br>` +
              error.response.data.error
          );
        });
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    listBtnGo() {
      this.$router.push("/notice");
    },
    noticeSubmit() {
      let idx = this.saveData.idx;
      let title = this.saveData.title;
      let content = this.saveData.content;
      let file = this.saveData.file;
      let confirmText = "등록";

      if (idx) {
        confirmText = "수정";
      }

      if (!title) {
        this.$alert("알림", "제목을 작성해주세요.");
        return false;
      }

      if (!content) {
        this.$alert("알림", "내용을 입력해주세요.");
        return false;
      }

      const formData = new FormData();
      if (idx) {
        formData.append("idx", idx);
      }
      formData.append("title", title);
      formData.append("content", content);
      formData.append("uploadFile", file);

      var response = this.$createConfirmResponse();
      this.$confirm(
        "알림",
        `공지사항 ${confirmText}하시겠습니까?`,
        "확인",
        "취소",
        response,
        {
          closed: () => {
            if (response.result) {
              axios
                .post("/api/admin/notice/noticeSubmit", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((result) => {
                  if (result.status == 200) {
                    this.$alert(
                      "알림",
                      `공지사항이 ${confirmText}되었습니다.`,
                      "",
                      {
                        closed: () => {
                          this.$router.push({
                            name: "noticeDetail",
                            params: { idx: result.data.IDX },
                          });
                        },
                      }
                    );
                  } else {
                    this.$alert(
                      "알림",
                      `공지사항이 ${confirmText}에 실패하였습니다.`
                    );
                  }
                })
                .catch((error) => {
                  this.$alert(
                    "알림",
                    `공지사항 ${confirmText}실패하였습니다. ` +
                      error.response.data
                  );
                });
            }
          },
        }
      );
    },
    detailNoticeInfo() {
      let idx = this.$route.params.idx;
      let param = {
        IDX: idx,
      };

      if (idx) {
        axios
          .post("/api/notice/getNoticeInfo", param)
          .then((response) => {
            if (response.status == 200) {
              let noticeData = response.data.NOTICE;
              this.saveData.idx = noticeData.IDX;
              this.saveData.title = noticeData.TITLE;
              this.saveData.content = noticeData.CONTENT;
              this.saveData.fileName = noticeData.FILE_NAME;

              this.submitText = "수 정";
            }
          })
          .catch((error) => {
            this.$alert(
              "알림",
              `공지사항 상세보기 불러오는데 실패하였습니다. <br>` +
                error.response.data.error
            );
          });
      }
    },
    setFile(file) {
      this.saveData.file = file;
    },
  },
};
</script>

<style scoped lang="scss"></style>
